import { trackClarityEvent } from '../../config/clarity';
import { GaAction, GaCategory, logGAEvent } from '../../config/googleAnalytics';
import { isDevEnv, userConsentGiven } from '../environment';

type LogAnalyticsEventParams = {
    category: GaCategory;
    action: GaAction;
    label: string;
    eventName: string;
};

export function logAnalyticsEvent({
    category,
    action,
    label,
    eventName,
}: LogAnalyticsEventParams) {
    if (!isDevEnv() && userConsentGiven()) {
        logGAEvent(category, action, label);
        trackClarityEvent(eventName);
    }
}
